<div class = "agpr-footer">
    <agpr-message
        [severity]="messageSeverityEnum.info"
        class="agpr-footer-infoRequired"
    >
        <p>
            {{ 'Discover.distribution.footer.settings.footerRequired.message' | localize }} <a
            href="http://help.agilitypr.com/en/articles/5409418-notice-on-international-regulations-on-email-communication" target="_blank">{{ 'Discover.distribution.footer.settings.footerRequired.link' | localize }}</a>.
        </p>
    </agpr-message>

    <div class="agpr-footer-fatLabel">
        {{'Discover.distribution.footer.settings.senderAddress' | localize}}
        <span
            role="img"
            class="fa-regular fa-circle-info agpr-footer-infoCircle"
            agprTooltip="Discover.distribution.footer.settings.senderAddress.tooltip"
        ></span>
    </div>
    <agpr-text-input
        class="agpr-textField-input"
        label="Discover.distribution.footer.settings.addressPreText"
        [id]="'addressPreText.input'"
        [(ngModel)]="value.addressPreText"
        (change)="emitChanges()"
        [maxLength]="255"
        [placeholder]="'Discover.distribution.footer.settings.addressPreText.placeholder' | localize"
    ></agpr-text-input>

    <agpr-text-input
        class="agpr-textField-input"
        label="Discover.distribution.footer.settings.company"
        [id]="'company.input'"
        [(ngModel)]="value.company"
        (change)="emitChanges('footerHasNoCompany')"
        [maxLength]="255"
        [placeholder]="'Discover.distribution.footer.settings.company.placeholder' | localize"
        tooltip="Discover.distribution.footer.settings.company.tooltip"
        required="true"
        [ariaInvalid]="errors?.footerHasNoCompany"
        ariaDescribedBy="footerErrors_company"
    ></agpr-text-input>
    <agpr-form-message id="footerErrors_company" *ngIf="errors?.footerHasNoCompany">
        {{ 'Discover.targeting.distribution.footer.errors.hasNoCompany' | localize }}
    </agpr-form-message>

    <agpr-text-input
        class="agpr-textField-input"
        label="Discover.distribution.footer.settings.streetAddress"
        [id]="'streetAddress.input'"
        [(ngModel)]="value.streetAddress"
        (change)="emitChanges('footerHasNoStreetAddress')"
        [maxLength]="255"
        [placeholder]="'Discover.distribution.footer.settings.streetAddress.placeholder' | localize"
        required="true"
        [ariaInvalid]="errors?.footerHasNoStreetAddress"
        ariaDescribedBy="footerErrors_streetAddress"
    ></agpr-text-input>
    <agpr-form-message id="footerErrors_streetAddress" *ngIf="errors?.footerHasNoStreetAddress">
        {{ 'Discover.targeting.distribution.footer.errors.hasNoStreetAddress' | localize }}
    </agpr-form-message>

    <agpr-text-input
        class="agpr-textField-input"
        label="Discover.distribution.footer.settings.city"
        [id]="'city.input'"
        [(ngModel)]="value.city"
        (change)="emitChanges('footerHasNoCity')"
        [maxLength]="255"
        [placeholder]="'Discover.distribution.footer.settings.city.placeholder' | localize"
        required="true"
        [ariaInvalid]="errors?.footerHasNoCity"
        ariaDescribedBy="footerErrors_city"
    ></agpr-text-input>
    <agpr-form-message id="footerErrors_city" *ngIf="errors?.footerHasNoCity">
        {{ 'Discover.targeting.distribution.footer.errors.hasNoCity' | localize }}
    </agpr-form-message>

    <agpr-text-input
        class="agpr-textField-input"
        label="Discover.distribution.footer.settings.province"
        [id]="'province.input'"
        [(ngModel)]="value.province"
        (change)="emitChanges()"
        [maxLength]="255"
        [placeholder]="'Discover.distribution.footer.settings.province.placeholder' | localize"
    ></agpr-text-input>

    <div class="agpr-footer-label">
        <label id="footerField_countryAutocompleteLabel">{{'Discover.distribution.footer.settings.country' | localize}}</label>
        <span class="agpr-requiredAsterix"> * </span>
    </div>
    <div class="agpr-footer-countryDropdown">
        <agpr-autocomplete
            [id]="'footer.country'"
            placeholder="Discover.distribution.footer.settings.country.placeholder"
            [(ngModel)]="value.country"
            [forceSelection]="false"
            [suggestionsFetcher]="journodexRegionsService.autoCompleteCountryLabelOnly.bind(journodexRegionsService)"
            [clearOnBlur]="false"
            (ngModelChange)="emitChanges('footerHasNoCountry')"
            ariaLabel="Discover.distribution.footer.settings.country"
            ariaLabelledBy="footerField_countryAutocompleteLabel"
            ariaDescribedBy="footerErrors_country"
            [ariaInvalid]="errors?.footerHasNoCountry"
        ></agpr-autocomplete>
    </div>
    <agpr-form-message id="footerErrors_country" *ngIf="errors?.footerHasNoCountry">
        {{ 'Discover.targeting.distribution.footer.errors.hasNoCountry' | localize }}
    </agpr-form-message>

    <agpr-text-input
        class="agpr-textField-input"
        label="Discover.distribution.footer.settings.postalCode"
        [id]="'postalCode.input'"
        [(ngModel)]="value.postalCode"
        (change)="emitChanges('footerHasNoZIP')"
        [maxLength]="255"
        [placeholder]="'Discover.distribution.footer.settings.postalCode.placeholder' | localize"
        required="true"
        [ariaInvalid]="errors?.footerHasNoZIP"
        ariaDescribedBy="footerErrors_zip"
    ></agpr-text-input>
    <agpr-form-message id="footerErrors_zip" *ngIf="errors?.footerHasNoZIP">
        {{ 'Discover.targeting.distribution.footer.errors.hasNoZIP' | localize }}
    </agpr-form-message>


    <div class="agpr-footer-fatLabel">
        {{'Discover.distribution.footer.settings.contactInfo' | localize}}
        <span class="agpr-requiredAsterix"> * </span>
        <span
            role="img"
            class="fa-regular fa-circle-info agpr-footer-infoCircle"
            agprTooltip="Discover.distribution.footer.settings.contactInfo.tooltip"
        ></span>
    </div>

    <div
        class="agpr-footer-contactInfo"
        role="radiogroup"
        [attr.aria-label]="'Discover.distribution.footer.settings.contactInfo' | localize"
        aria-describedby="footerErrors_contact"
        tabindex="0"
    >
        <div class="agpr-footer-contactInfo-inputGroup">
            <agpr-radio
                id="emailContactRadioButton"
                [value]="contactInfoTypesEnum.email"
                name="contact_option"
                label="Discover.distribution.footer.settings.email"
                hiddenLabel="Discover.distribution.footer.settings.email"
                [(ngModel)]="contactInfoType"
                (onClick)="setContactInfoType(contactInfoTypesEnum.email)"
                ariaDescribedBy="footerErrors_email"
            ></agpr-radio>
            <agpr-text-input
                *ngIf="contactInfoType === contactInfoTypesEnum.email"
                class="agpr-textField-input"
                ariaLabel="Discover.distribution.footer.settings.email"
                id="senderEmail.input"
                [(ngModel)]="value.senderEmail"
                [bottomMargin]="false"
                (change)="emitChanges('footerHasNoContact');validateEmailFormat()"
                [maxLength]="255"
                [placeholder]="'Discover.distribution.footer.settings.email.placeholder' | localize"
                [ariaInvalid]="(invalidEmail && value.senderEmail?.length > 0) || errors?.footerHasNoContact"
                ariaDescribedBy="footerErrors_email"
            ></agpr-text-input>
            <agpr-form-message id="footerErrors_email" *ngIf="invalidEmail && value.senderEmail?.length > 0">
                {{ 'Discover.distribution.footer.settings.email.validationMessage' | localize }}
            </agpr-form-message>
        </div>

        <div class="agpr-footer-contactInfo-inputGroup">
            <agpr-radio
                id="phoneContactRadioButton"
                [value]="contactInfoTypesEnum.phone"
                name="contact_option"
                label="Discover.distribution.footer.settings.phone"
                hiddenLabel="Discover.distribution.footer.settings.phone"
                [(ngModel)]="contactInfoType"
                (onClick)="setContactInfoType(contactInfoTypesEnum.phone)"
            ></agpr-radio>
            <agpr-text-input
                *ngIf="contactInfoType === contactInfoTypesEnum.phone"
                ariaLabel="Discover.distribution.footer.settings.email"
                class="agpr-textField-input"
                id="senderPhone.input"
                [(ngModel)]="value.senderPhone"
                (change)="emitChanges('footerHasNoContact')"
                [maxLength]="255"
                [placeholder]="'Discover.distribution.footer.settings.phone.placeholder' | localize"
                [ariaInvalid]="errors?.footerHasNoContact"
                ariaDescribedBy="footerErrors_contact"
            ></agpr-text-input>
        </div>
    </div>
    <agpr-form-message id="footerErrors_contact" *ngIf="errors?.footerHasNoContact">
        {{ 'Discover.targeting.distribution.footer.errors.hasNoContact' | localize }}
    </agpr-form-message>

    <div class="agpr-footer-fatLabel">
        {{'Discover.distribution.footer.settings.unsubLink' | localize}}
        <span
            role="img"
            class="fa-regular fa-circle-info agpr-footer-infoCircle"
            agprTooltip="Discover.distribution.footer.settings.unsub.tooltip"
        ></span>
    </div>

    <div class="agpr-footer-countryDropdown">
        <agpr-dropdown
            id="distributionFooter.unsubLanguage"
            [options]="unsubLanguageDropdownOptions"
            [(ngModel)]="selectedUnsubLanguageOption"
            (ngModelChange)="onSelectUnsubLanguage($event);"
            label="Discover.distribution.footer.settings.unsubLinkLanguage"
        >
        </agpr-dropdown>
    </div>
</div>
